import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const StepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${Spacing.S12};
`
